import type { StoreApi } from "zustand"
import { StoreState } from "./types"

export type State = {
  uploadIds: string[]
  activeId: string | null
  folderId?: string
}

export const slice = (
  set: StoreApi<StoreState>["setState"],
  get: StoreApi<StoreState>["getState"],
): State => ({
  uploadIds: [],
  activeId: null,
})
